class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', (event) => {
      const t = event.target;

      if (t.closest('.pv-size')) return;

      if (t.closest('.pv-price-range')) return;

      if (t.matches('[data-pv-ignore="1"]')) return;

      this.debouncedOnSubmit(event);
    });


    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    document.dispatchEvent(new CustomEvent('pv:dom-updated'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);

    document.dispatchEvent(new CustomEvent('facet:render'));
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const src = html.querySelector(selector);
      if (!src) return;

      const dest = document.querySelector(selector);
      if (!dest) return;

      dest.innerHTML = src.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (!mobileForm) return;

    const drawer = mobileForm.closest('menu-drawer');
    if (!drawer) return;

    if (typeof drawer.bindEvents === 'function') drawer.bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const sp = new URLSearchParams(window.location.search);

    form.querySelectorAll('input[name], select[name]').forEach((el) => {
      const name = el.name;
      if (!name) return;

      if (el.type === 'checkbox' || el.type === 'radio') {
        sp.delete(name);
      } else {
        sp.delete(name);
      }
    });

    const fd = new FormData(form);
    for (const [k, v] of fd.entries()) {
      sp.append(k, String(v));
    }

    return sp.toString();
  }


  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

(() => {
  const inited = window.__pvSizeInited || (window.__pvSizeInited = new WeakSet());

  const normLabel = (s) =>
    String(s || '')
      .replace('×', 'x')
      .replace(/\s/g, '')
      .toLowerCase();

  const parseDimsLongest = (label) => {
    // erwartet z.B. "30x60" / "30 x 60"
    const clean = normLabel(label);
    const parts = clean.split('x');
    if (parts.length < 2) return null;
    const a = parseInt(parts[0], 10);
    const b = parseInt(parts[1], 10);
    if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
    return Math.max(a, b);
  };

  const readJsonValues = (jsonId) => {
    const el = document.getElementById(jsonId);
    if (!el) return [];
    try {
      const arr = JSON.parse(el.textContent || '[]');
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  };

  const getAllParams = (param) => {
    try {
      return new URLSearchParams(window.location.search).getAll(param);
    } catch {
      return [];
    }
  };

  const PV_MIN_KEY = 'pv_size_min';
  const PV_MAX_KEY = 'pv_size_max';

  const writePvStateToSearchParams = (sp, min, max) => {
    if (min == null) sp.delete(PV_MIN_KEY); else sp.set(PV_MIN_KEY, String(min));
    if (max == null) sp.delete(PV_MAX_KEY); else sp.set(PV_MAX_KEY, String(max));
  };

  const readPvStateFromURL = () => {
    const sp = new URLSearchParams(window.location.search);
    const min = parseInt(sp.get(PV_MIN_KEY) || '', 10);
    const max = parseInt(sp.get(PV_MAX_KEY) || '', 10);
    return {
      min: Number.isFinite(min) ? min : null,
      max: Number.isFinite(max) ? max : null,
    };
  };

  const applyToDawn = (param, values, event, pvState = null) => {
    const url = new URL(window.location.href);

    url.searchParams.delete(param);
    values.forEach((v) => url.searchParams.append(param, v));

    if (pvState) {
      writePvStateToSearchParams(url.searchParams, pvState.min, pvState.max);
    } else {
      writePvStateToSearchParams(url.searchParams, null, null);
    }

    FacetFiltersForm.renderPage(url.searchParams.toString(), event || null);
  };

  const initOne = (root) => {
  const radioAll = root.querySelector('.pv-size-all');
  const groupChecks = Array.from(root.querySelectorAll('.pv-size-group'));
  const fieldsWrap = root.querySelector('.pv-size-fields');
  const applyBtn = root.querySelector('.pv-size-apply');

  const param = radioAll?.dataset.filterParam || fieldsWrap?.dataset.filterParam;
  const jsonId =
    groupChecks[0]?.dataset.valuesJsonId ||
    fieldsWrap?.dataset.valuesJsonId ||
    root.querySelector('[data-values-json-id]')?.dataset.valuesJsonId;

  if (!param || !jsonId) return;

  // Map: { value, longest }
  const raw = readJsonValues(jsonId);
  const mapped = raw
    .map((v) => {
      const longest = parseDimsLongest(v.label);
      if (!longest) return null;
      return { value: v.value, longest };
    })
    .filter(Boolean);

  const setRadioAll = (on) => {
    if (!radioAll) return;
    radioAll.checked = !!on;
  };

  const clearChecks = () => {
    groupChecks.forEach((c) => (c.checked = false));
  };

  const clearRangeInputs = () => {
    if (!fieldsWrap) return;
    const minEl = fieldsWrap.querySelector('.pv-size-min');
    const maxEl = fieldsWrap.querySelector('.pv-size-max');
    if (minEl) minEl.value = '';
    if (maxEl) maxEl.value = '';
    toggleApplyBtn();
  };

  const getMinMaxFromInputs = () => {
    const minEl = fieldsWrap?.querySelector('.pv-size-min');
    const maxEl = fieldsWrap?.querySelector('.pv-size-max');

    const min = minEl ? parseInt(String(minEl.value || '').replace(/[^\d]/g, ''), 10) : NaN;
    const max = maxEl ? parseInt(String(maxEl.value || '').replace(/[^\d]/g, ''), 10) : NaN;

    return {
      min: Number.isFinite(min) ? min : null,
      max: Number.isFinite(max) ? max : null,
    };
  };

  const toggleApplyBtn = () => {
    if (!applyBtn) return;
    const anyGroup = groupChecks.some((c) => c.checked);
    const { min, max } = getMinMaxFromInputs();
    const anyRange = min != null || max != null;
    // Auch anzeigen, wenn bereits ein Größen-Filter aktiv ist, damit man ihn
    // per "Anwenden" wieder entfernen kann, ohne dass sich das Dropdown schließt.
    const sizeApplied = getAllParams(param).length > 0;
    applyBtn.hidden = !(anyGroup || anyRange || sizeApplied);
  };

  const pickByRange = (min, max) => {
    const lo = min ?? 0;
    const hi = max ?? 999999;

    return mapped
      .filter((m) => m.longest >= lo && m.longest <= hi)
      .map((m) => m.value);
  };

  const pickByCheckedGroups = () => {
    const picked = new Set();

    groupChecks.forEach((c) => {
      if (!c.checked) return;
      const min = parseInt(c.dataset.min || '0', 10);
      const max = parseInt(c.dataset.max || '999999', 10);

      mapped
        .filter((m) => m.longest >= min && m.longest < max)
        .forEach((m) => picked.add(m.value));
    });

    return Array.from(picked);
  };

  const setChecksFromURL = () => {
    const active = new Set(getAllParams(param));
    const anyFacetValues = active.size > 0;

    const pv = readPvStateFromURL();
    const hasPvRange = pv.min != null || pv.max != null;

    setRadioAll(!(anyFacetValues || hasPvRange));

    if (hasPvRange) {
      const pMin = pv.min ?? null;
      const pMax = pv.max ?? null;

      groupChecks.forEach((c) => {
        const cMin = parseInt(c.dataset.min || '0', 10);
        const cMax = parseInt(c.dataset.max || '999999', 10);

        const isExactMatch =
          pMin != null &&
          pMax != null &&
          pMin === cMin &&
          pMax === cMax;

        c.checked = isExactMatch;
      });
    } else {
      groupChecks.forEach((c) => {
        const min = parseInt(c.dataset.min || '0', 10);
        const max = parseInt(c.dataset.max || '999999', 10);

        const anyInGroup = mapped.some(
          (m) => m.longest >= min && m.longest < max && active.has(m.value)
        );
        c.checked = anyInGroup;
      });
    }

    if (fieldsWrap) {
      const minEl = fieldsWrap.querySelector('.pv-size-min');
      const maxEl = fieldsWrap.querySelector('.pv-size-max');
      if (minEl) minEl.value = pv.min != null ? String(pv.min) : '';
      if (maxEl) maxEl.value = pv.max != null ? String(pv.max) : '';
    }

    toggleApplyBtn();
  };

  const applyCurrent = (event) => {
    const { min, max } = getMinMaxFromInputs();

    const hasRange = min != null || max != null;
    const hasGroups = groupChecks.some((c) => c.checked);

    let picked = [];

    if (hasRange && hasGroups) {
      // Intersection: Range ∩ Groups
      const a = new Set(pickByRange(min, max));
      const b = new Set(pickByCheckedGroups());
      picked = Array.from(a).filter((v) => b.has(v));
    } else if (hasRange) {
      picked = pickByRange(min, max);
    } else if (hasGroups) {
      picked = pickByCheckedGroups();
    } else {
      picked = [];
    }

    // ✅ WICHTIG:
    // - wenn nur Gruppen (oder Intersection) -> pv state LÖSCHEN
    // - wenn Range aktiv -> pv state setzen
    const pvState = hasRange ? { min, max } : null;

    applyToDawn(param, picked, event, pvState);
    setRadioAll(picked.length === 0 && !hasRange);
  };

  // ✅ Radio: Alle Größen
  if (radioAll) {
    radioAll.addEventListener('change', (e) => {
      if (!radioAll.checked) return;

      clearChecks();
      clearRangeInputs();

      // ✅ alles löschen (Facet + pv state)
      applyToDawn(param, [], e, null);
    });
  }

  // ✅ Checkbox Gruppen
  // WICHTIG: Nicht sofort anwenden/neu laden. Auswahl wird nur lokal gemerkt,
  // angewendet wird erst beim Klick auf "Anwenden". So bleibt das Dropdown offen
  // und man kann mehrere Größen (z.B. Miniatur + Klein) kombinieren.
  groupChecks.forEach((c) => {
    c.addEventListener('change', () => {
      if (c.checked) setRadioAll(false);

      const hasGroups = groupChecks.some((x) => x.checked);

      // Gruppen und Range schließen sich aus -> Range-Felder leeren
      if (hasGroups) clearRangeInputs();

      // Keine Gruppe mehr aktiv -> optisch "Alle Größen" markieren
      if (!hasGroups) setRadioAll(true);

      toggleApplyBtn();
    });
  });

  // ✅ Min/Max Inputs (nur Enter + Button)
  if (fieldsWrap) {
    const minEl = fieldsWrap.querySelector('.pv-size-min');
    const maxEl = fieldsWrap.querySelector('.pv-size-max');

    [minEl, maxEl].filter(Boolean).forEach((el) => {
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          const { min, max } = getMinMaxFromInputs();
          if (min == null || max == null) return;

          // ✅ beim Apply per Range: alle Gruppen aus + alle Größen aus
          clearChecks();
          setRadioAll(false);

          const picked = pickByRange(min, max);
          applyToDawn(param, picked, e, { min, max });
          toggleApplyBtn();
        }
      });

      el.addEventListener('input', () => {
        const { min, max } = getMinMaxFromInputs();
        if (min != null || max != null) setRadioAll(false);
        toggleApplyBtn();
      });
    });

    if (applyBtn) {
      // "Anwenden" wendet den gesamten aktuellen Panel-Zustand an
      // (Gruppen ODER Range) und löst genau EIN Neu-Laden aus.
      applyBtn.addEventListener('click', (e) => {
        applyCurrent(e);
        toggleApplyBtn();
      });

      toggleApplyBtn();
    }
  }

  setChecksFromURL();

  const pvInit = readPvStateFromURL();
  const hasPvRangeInit = pvInit.min != null && pvInit.max != null;

  if (hasPvRangeInit) {
    const spNow = new URLSearchParams(window.location.search);
    const alreadyHasDims = spNow.getAll(param).length > 0;

    const guardKey = `pv_auto_applied_${param}_${pvInit.min}_${pvInit.max}`;
    const alreadyAutoApplied = spNow.get(guardKey) === '1';

    if (!alreadyHasDims && !alreadyAutoApplied) {
      const picked = pickByRange(pvInit.min, pvInit.max);

      spNow.set(guardKey, '1');
      history.replaceState(
        { searchParams: spNow.toString() },
        '',
        `${window.location.pathname}?${spNow.toString()}`
      );

      if (picked.length > 0) {
        applyToDawn(param, picked, null, { min: pvInit.min, max: pvInit.max });
      } 
    }
  }

  root.__pvSizeResync = setChecksFromURL;
};


  const initAll = () => {
    document.querySelectorAll('.pv-size').forEach((root) => {
      if (inited.has(root)) return;
      inited.add(root);
      initOne(root);
    });

    document.querySelectorAll('.pv-size').forEach((root) => {
      if (typeof root.__pvSizeResync === 'function') root.__pvSizeResync();
    });
  };

  window.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('facet:render', initAll);
  document.addEventListener('pv:dom-updated', initAll);

  initAll();
})();

(() => {
  const GEN_CLASS = 'pv-size-pill-generated';

  const parseSizeValuesJSON = () => {
    const el = document.querySelector('script[id^="PvSizeValues-"]');
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch { return []; }
  };

  const normalizeLabelToLongest = (label) => {
    const lbl = String(label || '').replace('×','x').replace(/\s/g,'');
    const [a,b] = lbl.split('x').map(n => parseInt(n, 10));
    if (!Number.isFinite(a) || !Number.isFinite(b)) return null;
    return Math.max(a,b);
  };

  const pickValuesForRange = (values, min, max) => {
    return values
      .map(v => {
        const longest = normalizeLabelToLongest(v.label);
        if (longest == null) return null;
        return { value: v.value, longest };
      })
      .filter(v => v && v.longest >= min && v.longest < max)
      .map(v => v.value);
  };

  const buildParamsRemovingSpecificValues = (param, removeValuesSet) => {
    const sp = new URLSearchParams(window.location.search);
    const current = sp.getAll(param);

    // alle raus, dann nur die behalten, die NICHT entfernt werden sollen
    sp.delete(param);
    current
      .filter(v => !removeValuesSet.has(v))
      .forEach(v => sp.append(param, v));

    return sp.toString();
  };

  const PV_MIN_KEY = 'pv_size_min';
  const PV_MAX_KEY = 'pv_size_max';

  const readPvStateFromURL = () => {
    const sp = new URLSearchParams(window.location.search);
    const min = parseInt(sp.get(PV_MIN_KEY) || '', 10);
    const max = parseInt(sp.get(PV_MAX_KEY) || '', 10);
    return {
      min: Number.isFinite(min) ? min : null,
      max: Number.isFinite(max) ? max : null,
    };
  };

  const writePvStateToSearchParams = (sp, min, max) => {
    if (min == null) sp.delete(PV_MIN_KEY); else sp.set(PV_MIN_KEY, String(min));
    if (max == null) sp.delete(PV_MAX_KEY); else sp.set(PV_MAX_KEY, String(max));
  };

  const buildParamsClearingPvRange = (param) => {
    const sp = new URLSearchParams(window.location.search);

    sp.delete(PV_MIN_KEY);
    sp.delete(PV_MAX_KEY);

    sp.delete(param);

    return sp.toString();
  };

  const renderGroupPillsInActiveFacets = () => {
    const param =
      document.querySelector('.pv-size-all')?.dataset.filterParam ||
      document.querySelector('.pv-size-fields')?.dataset.filterParam;

    if (!param) return;

    const values = parseSizeValuesJSON();
    if (!values.length) return;

    document.querySelectorAll('.active-facets').forEach((container) => {
      const isDesktop = container.classList.contains('active-facets-desktop');

      container
        .querySelectorAll('.pv-size-pill-generated')
        .forEach((el) => el.remove());

      container
        .querySelectorAll('facet-remove a.active-facets__button')
        .forEach((a) => {
          if (
            (a.textContent || '').toLowerCase().includes('größe:') &&
            !a.closest('.pv-size-pill-generated')
          ) {
            a.closest('facet-remove')?.remove();
          }
        });

      let insertAfter = null;

      if (isDesktop) {
        insertAfter = container.querySelector('.active-facets-vertical-filter');
        if (!insertAfter) return;
      }

      const allRadio = document.querySelector('.pv-size-all');
      if (allRadio?.checked) return;

      const scopeRoot = isDesktop
        ? document.querySelector('#FacetFiltersForm')
        : document.querySelector('#FacetFiltersFormMobile');

      const checkedGroups = scopeRoot
        ? Array.from(scopeRoot.querySelectorAll('.pv-size-group:checked'))
        : [];

      const pv = readPvStateFromURL();
      const hasPvRange = pv.min != null && pv.max != null;

      if (hasPvRange && checkedGroups.length === 0) {
        const label = `Größe: ${pv.min}–${pv.max} cm`;
        const params = buildParamsClearingPvRange(param);

        const fr = document.createElement('facet-remove');
        fr.className = 'pv-size-pill-generated';

        fr.innerHTML = `
          <a href="?${params}" class="active-facets__button active-facets__button--light" role="button">
            <span class="active-facets__button-inner button button--tertiary">
              ${label}
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
                </svg>
              </span>
              <span class="visually-hidden">Filter entfernen</span>
            </span>
          </a>
        `;

        fr.querySelector('a')?.addEventListener('click', (e) => {
          e.preventDefault();
          FacetFiltersForm.renderPage(params, e);
        });

        if (isDesktop && insertAfter) {
          insertAfter.after(fr);
          insertAfter = fr;
        } else {
          container.appendChild(fr);
        }
      }


      if (!checkedGroups.length) return;

      checkedGroups.forEach((chk) => {
        const min = parseInt(chk.dataset.min, 10);
        const max = parseInt(chk.dataset.max, 10);

        const label =
          chk.closest('label')
            ?.querySelector('.pv-pill__label')
            ?.textContent?.trim() || 'Größe';

        const pickedValues = pickValuesForRange(values, min, max);
        if (!pickedValues.length) return;

        const removeSet = new Set(pickedValues);
        const params = buildParamsRemovingSpecificValues(param, removeSet);

        const fr = document.createElement('facet-remove');
        fr.className = 'pv-size-pill-generated';

        fr.innerHTML = `
          <a href="?${params}"
            class="active-facets__button active-facets__button--light"
            role="button">
            <span class="active-facets__button-inner button button--tertiary">
              Größe: ${label}
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    class="icon icon-close-small"
                    viewBox="0 0 12 13">
                  <path stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
                </svg>
              </span>
              <span class="visually-hidden">Filter entfernen</span>
            </span>
          </a>
        `;


        fr.querySelector('a')?.addEventListener('click', (e) => {
          e.preventDefault();
          FacetFiltersForm.renderPage(params, e);
        });

        // 👉 Desktop: NACH "Alle entfernen"
        if (isDesktop && insertAfter) {
          insertAfter.after(fr);
          insertAfter = fr; // nächstes Pill darunter
        } else {
          container.appendChild(fr);
        }
      });
    });
  };

  let scheduled = false;
  let running = false;

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      if (running) return;
      running = true;
      try {
        renderGroupPillsInActiveFacets();
      } finally {
        running = false;
      }
    });
  };

  window.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('facet:render', schedule);
})();

(() => {
  const ROOTS = ['#FacetFiltersForm', '#FacetFiltersFormMobile', '#FacetFiltersPillsForm'];

  function syncOneMediumBlock(block) {
    const radio = block.querySelector('.pv-medium-all');
    const checks = Array.from(block.querySelectorAll('.pv-medium-group'));
    const param = block.dataset.filterParam || checks[0]?.name;
    if (!radio || !checks.length || !param) return;

    const sp = new URLSearchParams(location.search);
    const active = new Set(sp.getAll(param));

    checks.forEach(c => (c.checked = active.has(c.value)));

    const anyChecked = checks.some(c => c.checked);

    radio.checked = !anyChecked;
    radio.defaultChecked = !anyChecked;

    if (anyChecked) radio.removeAttribute('checked');
    else radio.setAttribute('checked', 'checked');
  }

  function applyAllForBlock(block, event) {
    const radio = block.querySelector('.pv-medium-all');
    const checks = Array.from(block.querySelectorAll('.pv-medium-group'));
    const param = block.dataset.filterParam || checks[0]?.name;
    if (!radio || !checks.length || !param) return;

    checks.forEach(c => (c.checked = false));

    const sp = new URLSearchParams(location.search);
    sp.delete(param);

    FacetFiltersForm.renderPage(sp.toString(), event || null);

    radio.checked = true;
    radio.defaultChecked = true;
    radio.setAttribute('checked', 'checked');
  }

  function applyCheckedForBlock(block, event) {
    const checks = Array.from(block.querySelectorAll('.pv-medium-group'));
    const param = block.dataset.filterParam || checks[0]?.name;
    if (!param) return;

    const sp = new URLSearchParams(location.search);

    // diesen Facet-Parameter komplett neu setzen
    sp.delete(param);

    // aktive Werte wieder rein
    checks.filter(c => c.checked).forEach(c => sp.append(param, c.value));

    FacetFiltersForm.renderPage(sp.toString(), event || null);
  }

  function bindOneMediumBlock(block) {
    if (block.__pvMediumBound) return;
    block.__pvMediumBound = true;

    const radio = block.querySelector('.pv-medium-all');
    const checks = Array.from(block.querySelectorAll('.pv-medium-group'));
    if (!radio || !checks.length) return;

    radio.addEventListener('change', (e) => {
      if (!radio.checked) return;

      // alle Checkboxen aus
      checks.forEach(c => (c.checked = false));

      const sp = new URLSearchParams(location.search);
      const param = block.dataset.filterParam || checks[0]?.name;
      if (param) sp.delete(param);

      FacetFiltersForm.renderPage(sp.toString(), e);

      radio.checked = true;
      radio.defaultChecked = true;
      radio.setAttribute('checked', 'checked');
    });

    checks.forEach(c => {
      c.addEventListener('change', (e) => {
        const anyChecked = checks.some(x => x.checked);

        // Radio-UI sync
        radio.checked = !anyChecked;
        radio.defaultChecked = !anyChecked;
        if (anyChecked) radio.removeAttribute('checked');
        else radio.setAttribute('checked', 'checked');

        // ✅ DAS fehlte: URL + Ajax-Render aktualisieren
        applyCheckedForBlock(block, e);
      });
    });
  }

  let scheduled = false;
  function boot() {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;

      ROOTS.forEach(sel => {
        document.querySelectorAll(sel).forEach(root => {
          root.querySelectorAll('.pv-medium').forEach(block => {
            bindOneMediumBlock(block);
            syncOneMediumBlock(block);
          });
        });
      });

      // pv-medium Bloecke ausserhalb der Facet-Forms (z. B. die Chip-Bar "Thema"
      // in der Collection-Kopfzeile). bindOneMediumBlock ist via __pvMediumBound
      // gegen Doppel-Bindung abgesichert, syncOneMediumBlock ist idempotent.
      document.querySelectorAll('.pv-medium').forEach(block => {
        bindOneMediumBlock(block);
        syncOneMediumBlock(block);
      });
    });
  }

  window.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('popstate', boot);
  document.addEventListener('facet:render', boot);
})();

/* ------------------------------------------------------------------ *
 * Aktiv-Filter-Chips fuer den statischen "Thema"-Filter.
 * Da der Theme-Filter (mangels Eintrag in results.filters) nicht in den
 * nativen Aktiv-Chips auftaucht, werden die ausgewaehlten Themen hier aus
 * der URL nachgeruestet – analog zu den Groessen-Pills weiter oben.
 * ------------------------------------------------------------------ */
(() => {
  const THEME_PARAM = 'filter.p.m.custom.artwork_theme';

  // Der URL-Wert ist der englische Key (z.B. "travel"); das anzuzeigende
  // deutsche Label holen wir aus der gerenderten Theme-Checkbox.
  const labelForValue = (val) => {
    let input = null;
    try {
      input = document.querySelector(
        `.pv-medium-group[name="${THEME_PARAM}"][value="${(window.CSS && CSS.escape) ? CSS.escape(val) : val}"]`
      );
    } catch (e) { input = null; }
    const txt = input?.closest('label')?.querySelector('.pv-pill__label')?.textContent?.trim();
    return txt || val;
  };

  const paramsRemoving = (val) => {
    const sp = new URLSearchParams(window.location.search);
    const keep = sp.getAll(THEME_PARAM).filter((v) => v !== val);
    sp.delete(THEME_PARAM);
    keep.forEach((v) => sp.append(THEME_PARAM, v));
    return sp.toString();
  };

  const render = () => {
    const sp = new URLSearchParams(window.location.search);
    const values = sp.getAll(THEME_PARAM).filter(Boolean);

    document.querySelectorAll('.active-facets').forEach((container) => {
      const isDesktop = container.classList.contains('active-facets-desktop');

      // eigene, zuvor generierte Theme-Pills entfernen (Neu-Render)
      container.querySelectorAll('.pv-theme-pill-generated').forEach((el) => el.remove());
      if (!values.length) return;

      // Texte der bereits NATIV (von Shopify) gerenderten Chips. Praefixlos =
      // reiner Wert. Damit dedupen wir WERTGENAU: nur wenn fuer genau diesen
      // Theme-Wert schon ein nativer Chip existiert, ueberspringen wir ihn.
      const nativeContainsValue = (val) =>
        Array.from(
          container.querySelectorAll(
            'facet-remove:not(.pv-theme-pill-generated) a.active-facets__button .active-facets__button-inner'
          )
        ).some((el) => (el.textContent || '').includes(val));

      // Ziel = EXAKT das Eltern-Element der nativen Chips, damit die Theme-Chips
      // in derselben Flex-Reihe sitzen (sonst landen sie isoliert daneben).
      let target = container.querySelector('.active-facets-vertical-filter') || container;
      const sampleNative = container.querySelector(
        'facet-remove:not(.active-facets__button-wrapper):not(.pv-theme-pill-generated)'
      );
      if (sampleNative && sampleNative.parentNode) {
        target = sampleNative.parentNode;
      }

      values.forEach((val) => {
        if (nativeContainsValue(val)) return; // schon nativ vorhanden -> nicht doppeln
        const label = labelForValue(val);
        const params = paramsRemoving(val);

        const fr = document.createElement('facet-remove');
        fr.className = 'pv-theme-pill-generated';
        fr.innerHTML = `
          <a href="?${params}" class="active-facets__button active-facets__button--light" role="button">
            <span class="active-facets__button-inner button button--tertiary">
              ${label}
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"></path>
                </svg>
              </span>
              <span class="visually-hidden">Filter entfernen</span>
            </span>
          </a>
        `;

        fr.querySelector('a')?.addEventListener('click', (e) => {
          e.preventDefault();
          FacetFiltersForm.renderPage(params, e);
        });

        target.appendChild(fr);
      });
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      render();
    });
  };

  window.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('facet:render', schedule);
})();

/* ------------------------------------------------------------------ *
 * Aktiv-Zaehler-Badge je Thema-Kategorie (Accordion).
 * Zeigt an einer zugeklappten Kategorie, wie viele Themen darin
 * ausgewaehlt sind – so sieht man die Auswahl ohne aufzuklappen.
 * ------------------------------------------------------------------ */
(() => {
  const update = () => {
    document.querySelectorAll('.pv-theme-cat').forEach((cat) => {
      const n = cat.querySelectorAll('.pv-medium-group:checked').length;
      const badge = cat.querySelector('[data-cat-count]');
      if (!badge) return;
      if (n > 0) {
        badge.textContent = String(n);
        badge.classList.add('is-visible');
      } else {
        badge.textContent = '';
        badge.classList.remove('is-visible');
      }
    });
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      update();
    });
  };

  window.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('facet:render', schedule);
  // Nach dem URL-Sync der Checkboxen (pv-medium boot laeuft im rAF) nachziehen:
  document.addEventListener('facet:render', () => setTimeout(update, 60));
  window.addEventListener('DOMContentLoaded', () => setTimeout(update, 80));
  // Sofort bei Klick auf eine Theme-Checkbox:
  document.addEventListener('change', (e) => {
    if (e.target && e.target.closest && e.target.closest('.pv-theme-cat')) schedule();
  });
})();